// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Subscriptions_Billing360OverviewResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Subscriptions_Billing360OverviewResponse — response for GET /subscriptions/admin/billing-360-overview.
 */
import type { Subscriptions_Billing360OverviewRow } from './Subscriptions_Billing360OverviewRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Subscriptions_Billing360OverviewResponseDados {
rows: Subscriptions_Billing360OverviewRow[]
}

export type Subscriptions_Billing360OverviewResponse = ApiResponse<Subscriptions_Billing360OverviewResponseDados>;

registerResponseContract('Subscriptions_Billing360OverviewResponse', {
  rows: {
    type: 'array',
    required: true,
    items: {
      franchise_id:             { type: 'number',  required: true },
      franchise_name:           { type: 'string',  required: false },
      subscription_status:      { type: 'string',  required: false },
      subscription_plan_name:   { type: 'string',  required: false },
      subscription_provider:    { type: 'string',  required: false },
      subscription_currency:    { type: 'string',  required: false },
      subscription_price_cents: { type: 'number',  required: false },
      grace_status:             { type: 'string',  required: false },
      grace_until:              { type: 'string',  required: false },
      credits_balance_micro:    { type: 'number',  required: false },
      credits_reserved_micro:   { type: 'number',  required: false },
      setup_fee_status:         { type: 'string',  required: false },
      setup_fee_amount_cents:   { type: 'number',  required: false },
      setup_fee_currency:       { type: 'string',  required: false },
      setup_fee_charge_status:  { type: 'string',  required: false },
    },
  },
})
